import moment from "moment";
import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change as changeFieldValue, Field, getFormValues, reduxForm } from "redux-form";
import { Render } from "../../../../common";
import MessageBox from "../../../../common/MessageBox";
import { RadioGroup, SelectInput, TextInput } from "../../../../common/form";
import { FiscalSplitFields } from "./";
import fiscalSplitTypes from "./enums/fiscalSplitTypes";

import { ADMINISTRATOR, FINTECH } from "../../../../../utils/Roles";
import validationUtils from "../../../../../utils/ValidationUtils";
import * as dataActions from "../../../../../utils/data/dataActions";
import { BILLING_PERIODS } from "../../../../../utils/data/models";
import userHasAccess from "../../../../../utils/userHasAccess";
import { getErrorString } from "../../../../common/synchronization/SynchronizationHelper";
import { FAILURE, STARTED, SUCCESS } from "../../../synchronization/enums/syncStatusTypes";
import { RECURRING } from "../../enums/billingPeriodTypes";
import { IMPLEMENTATION } from "../../enums/clientStatusTypes";
import { DANGER, SUCCESS as SUCCESS_STATUS, WARNING } from "../../enums/messageBoxTypes";
import { ELIGIBILITY, TED_DESJARDINS } from "../../enums/synchronizationOptions";
import { CLASSES_VALIDATION_RULES } from "./classesValidationRules";


class BasicClassFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            warnings: {
                doubledGuarantee: false,
            },
        };

        this.setWarning = this.setWarning.bind(this);
        this.getStatus = this.getStatus.bind(this);
    }

    getChildContext() {
        return {
            scene: this.props.scene,
        };
    }


    componentWillMount() {
        const today = moment.utc().startOf("day").toISOString();
        let filters = [`clientId==${this.props.initialValues.clientId}`];
        if (this.props.clientBillingPeriodType === RECURRING.value) {
            filters.push(`startDate=lt=${today}`);
        }
        this.props.dataActions.getDataList(
            BILLING_PERIODS,
            0,
            0,
            "",
            ["startDate:desc"],
            filters
        );
        if (this.props.syncType === ELIGIBILITY.value && this.props.divisionOptions.length == 1 && !this.props.initialValues.classId){
            this.props.changeFieldValue("class","divisionId",this.props.divisionOptions[0].value);
        }
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(BILLING_PERIODS);
    }

    setWarning(warning, force = true) {
        const warnings = {
            ...this.state.warnings,
            [warning]: force,
        };
        this.setState({ warnings });
    }
    getStatus() {
        let classStatus = DANGER;
        let boxClassStatus = DANGER;
        const syncStatus = this.props.syncStatus;
        let errorStrings = [];
        if (syncStatus && Object.keys(syncStatus).length > 0) {
            switch (syncStatus.status) {
                case SUCCESS:
                    boxClassStatus = classStatus = SUCCESS_STATUS;
                    break;
                case STARTED:
                    boxClassStatus = WARNING;
                    classStatus = STARTED.toLowerCase();
                    break;
                case FAILURE:
                    classStatus = "dangerErrors";
                    if (syncStatus.errors && syncStatus.errors.length > 0) {
                        errorStrings = syncStatus.errors.map((error) =>
                            getErrorString([error], this.context.intl)
                        );
                    }
                    break;
                default:
                    break;
            }
        }
        return { classStatus, boxClassStatus, errorStrings };
    }
    render() {
        const { maximumRetroactiveDate,
            authLanguageCode,
            billingPeriodsList,
            fetchingMaximumRetroactiveDate,
            clientBillingPeriodType,
            divisionOptions,
            isNewClass, syncType, viewOnly } = this.props;

        let billingPeriods = [];
        const hasAdminAccess = userHasAccess([ADMINISTRATOR, FINTECH], true);
        if (fetchingMaximumRetroactiveDate === false) {
            billingPeriods = billingPeriodsList;

            billingPeriods = billingPeriods
                .filter(bp => !maximumRetroactiveDate || bp.startDate >= maximumRetroactiveDate)
                .map(billingPeriod => ({
                    value: billingPeriod.billingPeriodId,
                    text: billingPeriod.localizations[authLanguageCode].name,
                }));

            if (clientBillingPeriodType === RECURRING.value) {
                billingPeriods.unshift({
                    value: "nextBillingPeriod",
                    text: (
                        <FormattedMessage id="clientClasses.form.fiscalSplit.nextBillingPeriod" />
                    ),
                });
            }
        }
        const isMEVRecurring = this.props.clientStatusType == IMPLEMENTATION.value && clientBillingPeriodType == RECURRING.value;
        const { classStatus, boxClassStatus, errorStrings } = this.getStatus();
        const hasNoDivisions = this.props.syncType == ELIGIBILITY.value && this.props.divisionOptions.length == 0;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <fieldset disabled={this.props.disabled || hasNoDivisions}>
                    <Render if={!!this.props.initialValues.classId && this.props.syncStatus}>{
                        <MessageBox className={`alert-${boxClassStatus} class-message-box`}>
                            <span className="d-flex">
                                <FormattedMessage id={`clientClasses.form.syncDisplayStatus.${classStatus}`} />
                            </span>
                            {errorStrings && errorStrings.map((error, index) => (
                                <span key={index}>
                                    <span>{error}</span>
                                    <br />
                                </span>
                            ))}
                        </MessageBox>}
                    </Render>
                    <div className="sub-group">
                        <Field
                            id="name"
                            name="name"
                            component={TextInput}
                            required={true}
                            type="text"
                            label={<FormattedMessage id="clientClasses.form.name" />}
                        />
                        <Field
                            id="classNumber"
                            name="classNumber"
                            component={TextInput}
                            required={true}
                            type="text"
                            label={<FormattedMessage id="clientClasses.form.classNumber" />}
                        />
                        {syncType === ELIGIBILITY.value &&
                            ((Array.isArray(divisionOptions) && divisionOptions.length != 0) ? (<Field
                                id="divisionId"
                                name="divisionId"
                                component={SelectInput}
                                required={true}
                                options={divisionOptions}
                                searchable={true}
                                disabled={!isNewClass}
                                label={
                                    <FormattedMessage id="clientClasses.form.divisionId" />
                                }
                            />) :
                                isNewClass && (<MessageBox className="alert-danger">
                                    <FormattedMessage id="clientClasses.form.warnings.mandatoryDivision" />
                                </MessageBox>))}
                        {((hasAdminAccess && syncType === ELIGIBILITY.value) || (syncType === TED_DESJARDINS.value && !viewOnly)) && (
                            <Field
                                id="externalClassNumber"
                                name="externalClassNumber"
                                component={TextInput}
                                type="text"
                                label={<FormattedMessage id="clientClasses.form.externalClassNumber" />}
                            />
                        )}
                    </div>
                    <div className="sub-group value-type">
                        <Field
                            id="valueType"
                            name="valueType"
                            component={RadioGroup}
                            radios={fiscalSplitTypes}
                            label={
                                <FormattedMessage id="clientClasses.form.fiscalSplit.type" />
                            }
                        />
                    </div>
                    <Render if={!this.props.disabled}>
                        <div className="sub-group">
                            <Field
                                id="billingPeriodId"
                                name="billingPeriodId"
                                disabled={fetchingMaximumRetroactiveDate}
                                sortOptions={false}
                                required={true}
                                component={SelectInput}
                                options={billingPeriods}
                                label={
                                    <FormattedMessage id="clientClasses.form.fiscalSplit.startDate" />
                                }
                            />
                        </div>
                    </Render>
                    <Render
                        if={!this.props.disabled && !!this.props.initialValues.classId}
                    >
                        {fetchingMaximumRetroactiveDate === false &&
                            <MessageBox key="startDateWarning" className="alert-warning">
                                {
                                    isMEVRecurring ?
                                        <FormattedMessage id="clientClasses.form.warnings.startDateGeneric" />
                                        :
                                        (
                                            (maximumRetroactiveDate ?

                                                <FormattedMessage id="clientClasses.form.warnings.startDateForRecurring" values={{ date: maximumRetroactiveDate }} />
                                                :
                                                clientBillingPeriodType === RECURRING.value ?
                                                    <FormattedMessage id="clientClasses.form.warnings.startDate" />
                                                    :
                                                    <FormattedMessage id="clientClasses.form.warnings.startDateGeneric" />)
                                        )
                                }
                            </MessageBox>
                        }
                    </Render >
                    <Render
                        if={!this.props.disabled && this.state.warnings.doubledGuarantee}
                    >
                        <MessageBox key="doubledGuaranteeWarning" className="alert-warning">
                            <FormattedMessage id="clientClasses.form.warnings.doubledGuarantee" />
                        </MessageBox>
                    </Render>
                    {
                        this.props.formValues && (
                            <FiscalSplitFields
                                formValues={this.props.formValues}
                                disabled={this.props.disabled}
                                error={
                                    this.props.dirty || this.props.submitFailed
                                        ? this.props.error
                                        : null
                                }
                                setWarning={this.setWarning}
                                required={true}
                            />
                        )
                    }
                </fieldset >
            </form >
        );
    }
}

BasicClassFields.propTypes = {
    billingPeriodsList: PropTypes.array,
    dataActions: PropTypes.object,
    dirty: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.object,
    formValues: PropTypes.object,
    handleSubmit: PropTypes.func,
    initialValues: PropTypes.object,
    scene: PropTypes.string,
    submitFailed: PropTypes.bool,
    validation: PropTypes.object,
    maximumRetroactiveDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    authLanguageCode: PropTypes.string,
    clientStatusType: PropTypes.string,
    clientBillingPeriodType: PropTypes.string,
    fetchingMaximumRetroactiveDate: PropTypes.bool,
    isNewClass: PropTypes.bool,
    divisionOptions: PropTypes.array,
    syncType: PropTypes.string,
    syncStatus: PropTypes.object,
    changeFieldValue: PropTypes.func,
    viewOnly: PropTypes.bool
};

BasicClassFields.defaultProps = {
    disabled: false,
    scene: "",
};

BasicClassFields.contextTypes = {
    getData: PropTypes.func,
    intl: intlShape,
};

BasicClassFields.childContextTypes = {
    scene: PropTypes.string,
};

function mapStateToProps(state) {
    const billingPeriodsData = state.data.billingPeriods || {};
    return {
        billingPeriodsList: billingPeriodsData.items || [],
        formValues: getFormValues("class")(state),
        authLanguageCode: state.auth.user.languageCode,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "class",
        validate: (values) =>
            validationUtils.validate(values, CLASSES_VALIDATION_RULES),
    })(BasicClassFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/BasicClassFields.js